// DS: i3.4
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const ChevronRight: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.707 6.293l4.95 4.95a1 1 0 010 1.414l-4.95 4.95a1 1 0 01-1.414-1.415l4.242-4.243-4.242-4.242a1 1 0 011.414-1.414z" />
    </svg>
  </IconWrap>
);
ChevronRight.displayName = 'ChevronRight';

export default ChevronRight;
